<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
  <bp-modal-header header [title]="'swap_crypto' | translate">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <img class="success-image" src="/assets/images/success.svg" [alt]="'swap_successful' | translate" />
      <div class="success-headline mb-15">{{ "swap_successful" | translate }}</div>
      @if (!isIndexSwap()) {
        <p class="text-center mb-15 swap-success-text">
          <!-- From -->
          <span>{{ "swap_success_text" | translate }}</span>
          <br />
          <strong>
            {{
            swapSuccessTrades[0]?.getAmountTradable()
            | tradable_precision_symbol
            : { id: swapSuccessTrades[0]?.getCurrencyId(), dustThreshold: 0.0001 }
            }}
            {{ getCurrencySymbol(swapSuccessTrades[0]) }}
          </strong>
          ({{ swapSuccessTrades[0]?.getCurrencyId() | tradable_name }})
          {{ "into_success_screen" | translate }}
          <!-- To -->
          <strong>
            {{
            swapSuccessTrades[1]?.getAmountTradable()
            | tradable_precision_symbol
            : { id: swapSuccessTrades[1]?.getCurrencyId(), dustThreshold: 0.0001 }
            }}
            {{ getCurrencySymbol(swapSuccessTrades[1]) }}
          </strong>
          ({{ swapSuccessTrades[1]?.getCurrencyId() | tradable_name }})
        </p>
      } @else {
        <p class="text-center mb-15 font-size-17">
          @switch (getIndexSwapType()) {
            @case ('fromIndex') {
              <span
								[innerHTML]="
									'swap_index_from_success'
										| translate
											: [
													swapSuccessTrades[0]?.getAmount()
														| fiat_precision_symbol: getIndexPipeOption(),
													getTradableName(0),
													(swapSuccessTrades[1]?.getAmountTradable()
														| tradable_precision_symbol
															: {
																	id: swapSuccessTrades[1]?.getCurrencyId(),
																	dustThreshold: 0.0001
															  }) +
														' (' +
														getTradableName(1) +
														')'
											  ]
											: false
								"></span>
            }
            @case ('toIndex') {
              <span
								[innerHTML]="
									'swap_index_to_success'
										| translate
											: [
													swapSuccessTrades[0]?.getAmountTradable()
														| tradable_precision_symbol
															: {
																	id: swapSuccessTrades[0]?.getCurrencyId(),
																	dustThreshold: 0.0001
															  },
													swapSuccessTrades[1]?.getAmount()
														| fiat_precision_symbol: getIndexPipeOption(),
													getTradableName(1)
											  ]
											: false
								"></span>
            }
            @case ('betweenIndex') {
              <span
								[innerHTML]="
									'swap_index_to_index_success'
										| translate
											: [
													swapSuccessTrades[0]?.getAmount()
														| fiat_precision_symbol: getIndexPipeOption(),
													getTradableName(0),
													swapSuccessTrades[1]?.getAmount()
														| fiat_precision_symbol: getIndexPipeOption(),
													getTradableName(1)
											  ]
											: false
								"></span>
            }
          }
        </p>
      }

      <!-- Tax withholding info -->
      @if (swapSuccessTrades[0]?.gettaxWithheld(); as tax) {
        <tax-success-amount-label-ui
          [taxWithheld]="tax"
        type="ASSET"></tax-success-amount-label-ui>
      }

      <!-- Taxes Temporary info -->
      @if (
        swapSuccessTrades[0]?.gettaxWithheld()?.isTaxServiceAvailable === false &&
        +swapSuccessTrades[0]?.gettaxWithheld()?.taxAmountFiat > 0
        ) {
        <span
          class="temporary-tax"
          >
          <img [src]="'/assets/images/success-taxes-warning.svg'" [alt]="'alt_text' | translate" />
          {{ "tw_success_screen_temporary" | translate }}
        </span>
      }

      <!-- Vision info -->
      @if ((stakingVm$ | async) && showVisionWarning) {
        <p class="swap-success-text">
          {{
          "auto_staking_trade_success_vision_warning"
          | translate: [getTradableName(1), getTradableSymbol(1)]
          }}
        </p>
      }
    </div>
    <div class="mb-30 flex price-alert-buttons">
      @for (trade of swapSuccessTrades; track trade; let i = $index) {
        @if (!isIndex(trade)) {
          <button
            (click)="addPriceAlert(trade.getCurrencyId())"
            class="btn btn-primary btn-success-modal mod-middle button-weight"
            type="button">
            {{ "add_pricealert" | translate: [getTradableSymbol(i)] }}
          </button>
        }
      }
    </div>
    @let visionId = visionId$ | async;
    @let isUkUser = isUkUser$ | async;
    @if (
      ((visionFeeFlag$ | async) &&
      !isUkUser &&
      visionFeeTokenCollection?.feeDiscount &&
      (visionFeeTokenCollection?.eligibleForVsn ||
      visionId.getId() === swapSuccessTrades[0]?.getCurrencyId() ||
      visionId.getId() === swapSuccessTrades[1]?.getCurrencyId()) &&
      visionFeeTokenCollection?.globalOptIn === false) ||
      (visionFeeTokenCollection?.globalOptIn &&
      visionFeeTokenCollection?.visionFeeDetail?.hasEnoughFunds === false)
      ) {
      <div class="swap-vision-banner-container">
        <mo-success-vision-component
          [feeAmount]="visionFeeTokenCollection?.feeDiscount"
					[bannerState]="
						!visionFeeTokenCollection?.globalOptIn
							? MoSuccessVisionBannerState.VISIONFEENOTACTIVE
							: MoSuccessVisionBannerState.OPTEDININSUFFICIENTFUNDS
					"
          (click)="handleBannerClick()">
        </mo-success-vision-component>
      </div>
    }
    @if (showVisionWarning && assetAvailableToStake) {
      <div class="staking-button">
        <a (click)="startStakingFlow(swapSuccessTrades[1].getCurrencyId())" class="link-primary">
          {{ "button_stake" | translate: [getTradableSymbol(1)] }}
        </a>
      </div>
    }
    <div class="text-center">
      <button (click)="goToPortfolio()" class="btn btn-primary btn-success-modal" type="button">
        <strong>{{ "go_to_portfolio" | translate }}</strong>
      </button>
    </div>
  </div>
</success-screen>
